import HARDCODE from '../../../business-const/HardCode/HardCode'

import tipoOrigemClienteList from '../../../business-rules/List/tipoOrigemClienteList'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import {
    atualizaFormListCepResidencial
} from '../cadastro-form/CadastroServiceEndereco'



const calculaClienteClienteRecomendou = ( values ) => {

    const linhaTipoOrigemClienteList = pesquisaList(tipoOrigemClienteList(null, false), values.tipoOrigemCliente)

    if (linhaTipoOrigemClienteList.informaClienteRecomendou !== "S") {
        values.clienteRecomendou = ''
    }
}

const calculaClienteTipoOrigemClienteOutras = ( values ) => {
    
    const linhaTipoOrigemClienteList = pesquisaList(tipoOrigemClienteList(null, false), values.tipoOrigemCliente)

    if (linhaTipoOrigemClienteList.informaTipoOrigemClienteOutras !== "S") {
        values.tipoOrigemClienteOutras = ''
    }
}

export const processaAlteracaoClienteTipoOrigemCliente = ( values ) => {
    calculaClienteClienteRecomendou(values)
    calculaClienteTipoOrigemClienteOutras(values)
}



const calculaClienteProfissaoClienteOutras = ( values ) => {

    if (
            values.profissaoCliente !== HARDCODE.profissaoOutras &&
            (
                values.profissaoCliente &&
                values.profissaoCliente.indexOf(HARDCODE.profissaoOutrasFuncionarioPublico) === -1
            )
    ) {

        values.profissaoClienteOutras = '' 
    }
}

export const processaAlteracaoClienteProfissaoCliente = ( values ) => {
    calculaClienteProfissaoClienteOutras(values)
}



export const processaAlteracaoClientePossuiConjuge = ( values ) => {
    if (!values.possuiConjuge) {
        values.tipoRegimeBens = ''
        values.percHerancaFamiliarDiferenteConjuge = ''
        
        values.nomeConjuge = ''
        values.nomeCurtoConjuge = ''
        values.cpfConjuge = ''
        values.nascimentoConjuge = null
        values.idadeConjuge = ''
        values.sexoConjuge = ''
        values.grauInstrucaoConjuge = ''
        values.formacaoConjuge = ''
        values.profissaoConjuge = ''
        values.empresaConjuge = ''
        values.ocupacaoConjuge = ''
        values.profissaoConjugeOutras = ''

        if (values.contatos) {

            let indexContatos = values.contatos.length - 1

            while (indexContatos >= 0) {

                if (values.contatos[indexContatos].familiar === HARDCODE.idFamiliarConjuge) {
                        
                    values.contatos.splice(indexContatos, 1)
                }

                indexContatos -= 1
            }
        }
    }
}



export const processaAlteracaoCepResidencial = ( variaveisGlobais, values ) => {

    atualizaFormListCepResidencial(variaveisGlobais, values)
}
